import React from 'react'
import PropTypes from 'prop-types'
import { getNameRelatedData } from '@fs/zion-person-service'
import { useTranslation } from 'react-i18next'
import { css } from '@linaria/core'
import InfoCard from '../info-card/PersonInfoCard'
import Activity from './Activity'

import heritageSVG from './assets/heritage.svg'
import traditionalDressSVG from './assets/traditional-dress.svg'

const spacingCss = css`
  display: grid;
  grid-row-gap: 20px;
  margin-top: 8px;
`

export default function ActivitiesCard({ person, baseUrl, ...props }) {
  const [t] = useTranslation()
  const { shortName } = getNameRelatedData(person)

  return (
    <InfoCard heading={t('info-cards.activities.header')} {...props}>
      <div className={spacingCss}>
        <Activity
          heading={t('info-cards.activities.heritage.header')}
          to={`${baseUrl || ''}/discovery/explore/heritage`}
          imageSrc={heritageSVG}
          description={t('info-cards.activities.heritage.description', { shortName })}
          linkName="Heritage"
        />
        <Activity
          heading={t('info-cards.activities.traditional-dress.header')}
          to={`${baseUrl || ''}/discovery/picture/select`}
          imageSrc={traditionalDressSVG}
          description={t('info-cards.activities.traditional-dress.description', { shortName })}
          linkName="Traditional Dress"
        />
      </div>
    </InfoCard>
  )
}

// Stryker disable all
ActivitiesCard.propTypes = {
  /** Person object. */
  person: PropTypes.shape({}),

  /** URLs for each of the activities relevant to the focused person. */
  urls: PropTypes.shape({
    heritage: PropTypes.string,
    'traditional-dress': PropTypes.string,
    // 'ancestor-map': PropTypes.string,
    // 'compare-your-faces': PropTypes.string,
  }),
}
